import { create } from 'zustand';
import { ILesson } from '../models/lesson';
import { createJSONStorage, persist } from 'zustand/middleware';

interface ILessonInfo {
  module: string;
}

interface ILessonRequestState {
  lessons: ILesson[];
  lessonInfo: ILessonInfo | null;
  setLessons: (lessons: ILesson[]) => void;
  setLessonInfo: (lessonInfo: ILessonInfo) => void;
  resetLessons: () => void;
}

export const useLessonRequestStore = create<ILessonRequestState>()(
    (set) => ({
      lessons: [],
      lessonInfo: null,
      setLessons: (lessons: ILesson[]) => set({ lessons }),
      setLessonInfo: (lessonInfo: ILessonInfo) => set({ lessonInfo }),
      resetLessons: () => set({ lessons: [], lessonInfo: null }),
    })
);